/**
 * One status-color map for Dispatch + Pilot chips (board, Trips, Plans, Log, Gantt).
 * CSS tokens live on the desk; this only names the shared tone → class.
 */
import type { FlightLogStatus, TicketLifecycle } from "./types";

export type TicketStatusTone =
  | "scheduled"
  | "accepted"
  | "enroute"
  | "airborne"
  | "divert"
  | "arrived"
  | "cancelled"
  | "grounded";

export const TICKET_STATUS_TONES: readonly TicketStatusTone[] = [
  "scheduled",
  "accepted",
  "enroute",
  "airborne",
  "divert",
  "arrived",
  "cancelled",
  "grounded",
];

export const TICKET_STATUS_TONE: Record<TicketLifecycle, TicketStatusTone> = {
  scheduled: "scheduled",
  accepted: "accepted",
  active: "accepted",
  taxi: "enroute",
  airborne: "airborne",
  diverting: "divert",
  diverted: "divert",
  arrived: "arrived",
  completed: "arrived",
  cancelled: "cancelled",
};

export const LOG_STATUS_TONE: Record<FlightLogStatus, TicketStatusTone> = {
  filed: "scheduled",
  accepted: "accepted",
  taxi: "enroute",
  airborne: "airborne",
  diverting: "divert",
  diverted: "divert",
  arrived: "arrived",
  complete: "arrived",
  cancelled: "cancelled",
};

export const TICKET_STATUS_TONE_TOKEN: Record<TicketStatusTone, string> = {
  scheduled: "--status-scheduled",
  accepted: "--status-accepted",
  enroute: "--status-enroute",
  airborne: "--status-airborne",
  divert: "--status-divert",
  arrived: "--status-arrived",
  cancelled: "--status-cancelled",
  grounded: "--status-grounded",
};

export const GANTT_STATUS_LEGEND: readonly { tone: TicketStatusTone; label: string }[] = [
  { tone: "scheduled", label: "Scheduled" },
  { tone: "accepted", label: "Accepted" },
  { tone: "enroute", label: "En route" },
  { tone: "airborne", label: "Airborne" },
  { tone: "divert", label: "Divert" },
  { tone: "arrived", label: "Arrived" },
  { tone: "cancelled", label: "Cancelled" },
  { tone: "grounded", label: "Downed / AOG" },
];

export function ticketStatusTone(lifecycle: TicketLifecycle): TicketStatusTone {
  return TICKET_STATUS_TONE[lifecycle] ?? "scheduled";
}

export function ticketStatusPillClass(lifecycle: TicketLifecycle): string {
  return `pill-life-${ticketStatusTone(lifecycle)}`;
}

export function flightLogStatusTone(status: FlightLogStatus): TicketStatusTone {
  return LOG_STATUS_TONE[status] ?? "scheduled";
}

export function flightLogStatusPillClass(status: FlightLogStatus): string {
  return `pill-life-${flightLogStatusTone(status)}`;
}

export function ganttBarClassForTone(tone: TicketStatusTone): string {
  return `gantt-bar is-tone-${tone}`;
}
